import { render, staticRenderFns } from "./product-card-loader.vue?vue&type=template&id=5274ddcc&scoped=true"
import script from "./product-card-loader.vue?vue&type=script&lang=js"
export * from "./product-card-loader.vue?vue&type=script&lang=js"
import style0 from "./product-card-loader.vue?vue&type=style&index=0&id=5274ddcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274ddcc",
  null
  
)

export default component.exports